<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="job-posts placements agreements margin-top-service-30px">
  <div class="card skillassest-form">
    <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
      Services Configuration
    </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-0px">
    <div class="row">

      <div class="position-fixed-service border-right2 padding-right-0px">
        <div class="card">

          <div class="card-header wh-header header3 padding-right-32px bk-color-light padding-bottom-0px">
            <div class="row margin-top10px margin-left-20px  nav-link-hand" (click)="back()">

              <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                Services Revenue
              </label>
              <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Tests"
                 *ngIf="ShowIcon" (click)="back()"><i class="fas fa-angle-double-left font-size-19px"></i></a>

            </div>
            <!--<div class="row margin-left-zero margin-top-10">
              Categories
            </div>-->



          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">
            <div class="row border-top border-bottom padding-top-10px padding-bottom-10px margin-right-0px margin-left16px">
              <div class="col-md-10 padding-right-0px padding-left-0px margin-left-17px display-inherit">
                <!--<form novalidate="" #f="ngForm" class="display-inherit">
    <div class="clear-form">
      <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
      <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
    </div>
    <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime Go-button margin-right-auto margin-left-5px">Go</button>
  </form>-->
                <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
              </div>
              <!--<div class="col-md-2 padding-top-2px padding-left-10px">
                <button type="button" class="btn btn-new btn-sm" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>

              </div>-->


            </div>
            <div>
              <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                <div class="row border-bottom rowfor margin-left16px nav-link-hand edit_hover_class" (click)="Selectedlab(l)" *ngFor="let l of pdata">

                  <div class="col-md-10">

                    <label class="margin-bottom-0px nav-link-hand font-size-13px margin-left-5px">{{l.ServiceName}}</label>
                  </div>
                  <!--<div class="col-md-2 padding-left-0px">
                    <a> <i class="fas fa-pencil-alt nav-link-hand"></i></a>
                  </div>-->

                </div>

                <!--<div class="row border-bottom rowfor margin-left16px nav-link-hand edit_hover_class" (click)="viewservice1()">

                  <div class="col-md-10">

                    <label class="margin-bottom-0px nav-link-hand font-size-13px margin-left-5px">Harmonal Assay</label>
                  </div>
                  <div class="col-md-2 padding-left-0px">
                    <a> <i class="fas fa-pencil-alt nav-link-hand"></i></a>
                  </div>

                </div>-->

              </div>
            </div>

          </div>

        </div>
      </div>
      <div class="offset-md-2 col-md-10 padding-left-42px" *ngIf="ShowService">
        <div class="card">

        </div>
        <div class="row">
        <div class="col-md-12 padding-left-0px">
        <div class="card">
        <div class="card-header wh-header border-bottom padding-top-5px padding-left-5px padding-bottom-5px">
        <div class="row" *ngIf="SelectedlabDetails">
        <div class="col-md-4 padding-right-0px padding-left-0px">
        <div class="row font-size-16px">
        <div class="col-md-5 padding-right-4px text-align-right padding-left-0px">
        <label class="font-weight-bold font-size-15px margin-bottom-0px">Selected Service </label>
        </div>-
        <div class="col-md-5 padding-right-0px padding-left-5px text-align-left">
          <label class="font-weight-bold font-size-15px margin-bottom-0px color-Assign">{{SelectedlabDetails.ServiceName}}</label>
        </div>
        </div>
        </div>
        <div class="col-md-4 padding-right-0px padding-left-0px">
        <div class="row font-size-16px">
        <div class="col-md-4 padding-right-4px text-align-right padding-left-0px">
        <label class="font-weight-bold font-size-15px margin-bottom-0px">Group Name </label>
        </div>-
        <div class="col-md-7 padding-right-0px padding-left-5px text-align-left">
          <label class="font-weight-bold font-size-15px margin-bottom-0px color-Assign">{{SelectedlabDetails.CategoryName}}</label>
        </div>
        </div>
        </div>
        <!--<div class="col-md-3 padding-right-0px"><label class="label-size-2 font-color-secondary">Selected Material</label></div>:
  <div class="col-md-4 text-align-left"><label class="label-size-2">{{SelectedlabDetails.Description}}</label></div>-->
        <!--<div class="col-md-3 padding-right-0px"><label class="label-size-2 font-color-secondary"> Group Name</label></div>:
  <div class="col-md-4 text-align-left"><label class="label-size-2">{{SelectedlabDetails.GroupName}}</label></div>-->
        <!--<div class="col-md-4 padding-left-0px">
    <div class="row margin-left-zero margin-right-0px">
      <div class="col-md-8 padding-right-0px float-left">
        <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
      </div>

      <div class="col-md-3 padding-right-8px padding-bottom-4px padding-top-4px rowfor1">
        <a class="float-right" (click)="addtestmodal()"><i class="fas fa-plus nav-link-hand"></i><label class="margin-bottom-0px padding-left-5px font-size-18px">Tests</label></a>
      </div>


    </div>
  </div>-->
        </div>
        </div>
        <div class="card-body padding-top-0px">
        <div class="row border-bottom-1px">
        <div class="col-md-12 padding-right-0px">
        <div class="row padding-top-5px padding-bottom-5px">
        <div class="col-md-1 max-width-8pe padding-right padding-left-0px text-align-right margin-top-5px margin-left-4px">
        <label class="margin-right-3px margin-bottom-0px font-size-16px font-weight-bold">Branch :</label>
        </div>
        <div class="col-md-2 padding-left-0px padding-right-0px">

          <CustomDataByRequestType RequestedType="FacilityList" class="padding-change" ActorCode={{ActorCode}}
                                   (keyChange)="Roleassign($event)"
                                   [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                   required>
          </CustomDataByRequestType>
        </div>

        <div class="col-md-1 padding-right padding-left-0px margin-top-5px margin-left-10px">
        <label class="margin-right-3px margin-bottom-0px font-size-16px font-weight-bold">From Date :</label>
        </div>
        <div class="col-md-2 padding-left-0px padding-right-0px max-width-10pe">
        <div class="date-form">
        <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
        name="SelectedFrom" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker">

        <a (click)="d.toggle()" class="nav-link-hand">
        <span class="date-icon margin-top-3px"><i class="far fa-calendar-alt"></i></span>

        </a>

        </div>
        </div>
        <div class="col-md-1 padding-right  margin-top-5px">
        <label class="margin-right-3px margin-bottom-0px font-size-16px font-weight-bold">To Date :</label>
        </div>
        <div class="col-md-2 padding-left-0px padding-right-0px max-width-10pe">
        <div class="date-form">
        <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-16px data-color-new" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
        name="SelectedTo" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker">

        <a (click)="d1.toggle()" class="nav-link-hand">
        <span class="date-icon margin-top-3px"><i class="far fa-calendar-alt"></i></span>

        </a>

        </div>
        </div>



        <!--<div class="col-md-3 float-right padding-right-0px padding-l-0px display-inherit">
    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

  </div>-->
        <div class="max-width-12pe padding-left-0px padding-top-3px">
        <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="Go()">Go</button>
        <a class="nav-link-hand education-navlink data-color-new margin-left-10px" title="print" (click)="printservicerevenue()">
        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
        </a>
        <!--<button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>-->
        </div>
        <div class="col-md-1 padding-left-0px">

        </div>
        <!--<div class="max-width-12pe padding-left-0px">
    <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-10px" (click)="LoadForms()">Go</button>
    <button class="btn font-size-13px actions-btn-prime  margin-left-5px" title="print" (click)="printexpenses()">GetReport</button>
  </div>-->
        </div>
        </div>
        </div>
        <div class="row">
        <div class="col-md-12">


        <ul class="nav nav-tabs nav-tab-service2 margin-top-13px" id="tabContent">
        <!--<li class="active margin-right-15px"><a class="nav-itemerp active" href="#batches" data-toggle="tab">Batches</a></li>-->
        <li class="margin-right-15px"><a class="nav-itemerp active" href="#sales" data-toggle="tab">Sales</a></li>
        <!--<li class="margin-right-15px"><a class="nav-itemerp" href="#purchases" data-toggle="tab">Purchases</a></li>-->
        </ul>

        <div class="tab-content">

        

        <div class="tab-pane active" id="sales">

        <div class="row margin-left-10px margin-top-5px" *ngIf="length2>0">
        <!--<div class="col-md-3 margin-left-10px margin-top-5px">
    <div class="card Ipbillcard-border">
      <div class="card-body padding-all-8px">
        <div class="row">
          <div class="col-md-6">
            <label class="margin-bottom-0px font-size-14">Total Advance</label>
          </div>:
          <div class="col-md-5">

            <label class="margin-bottom-0px font-size-14">25000</label>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="margin-bottom-0px font-size-14">Total Bill</label>
          </div>:
          <div class="col-md-5">
            <label class="margin-bottom-0px font-size-14">45000</label>
          </div>
        </div>
        <div class="row border-top-due">
          <div class="col-md-6">
            <label class="margin-bottom-0px font-size-14">Due</label>
          </div>:
          <div class="col-md-5">
            <label class="margin-bottom-0px font-size-14">20000</label>
          </div>
        </div>
      </div>
    </div>
  </div>-->
        <div class="col-md-2 mistable-data2">
        <div class="row margin-left-0px font-size-12px font-weight-bold">
        No.of Sales
        </div>
        <div class="row margin-left-0px misdatafont" *ngIf="nofsales">
        {{nofsales}}
        </div>
        </div>
        <div class="col-md-2 mistable-data2">
        <div class="row margin-left-0px font-size-12px font-weight-bold">
        Grand Total
        </div>
        <div class="row margin-left-0px misdatafont" *ngIf="GrandTotal">
        {{GrandTotal| number:'1.2-2' |removeComma}}
        </div>
        </div>
        <div class="col-md-2 mistable-data2">
        <div class="row margin-left-0px font-size-12px font-weight-bold">
        Total Discount
        </div>
        <div class="row margin-left-0px misdatafont" *ngIf="TotalDiscountsa">
        {{TotalDiscountsa| number:'1.2-2' |removeComma}}
        </div>
        </div>
        <div class="col-md-2 mistable-data2" hidden>
        <div class="row margin-left-0px font-size-12px font-weight-bold">
        Total Tax
        </div>
        <div class="row margin-left-0px misdatafont" *ngIf="TotalTax">
        {{TotalTax| number:'1.2-2' |removeComma}}
        </div>
        </div>
        <div class="col-md-2 mistable-data2">
        <div class="row margin-left-0px font-size-12px font-weight-bold">
        Total Amount
        </div>
        <div class="row margin-left-0px misdatafont" *ngIf="Totalsales">
        {{Totalsales| number:'1.2-2' |removeComma}}
        </div>
        </div>

        </div>
        <div class="row margin-top-5px" *ngIf="length2>0">
        <div class="col-md-12">

        <div class="table-component">
        <div class="table-responsive overflow-x">


        <table class="table table-striped margin-left-20p table-fixed"
        cols="auto,2*,*,*,*,*,*,*">

        <thead class="">
        <tr>


        <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-9px">
        Date
        </th>

        <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
        Patient
        </th>
        <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-8px">
        Qty
        </th>
        <th class=" padding-top-4px padding-bottom-4px th-sticky padding-left-0px padding-right-8px">
        Price
        </th>

        <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
        Item Total
        </th>

        <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-8px">
        Disc
        </th>
      
        <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px padding-left-5px">
        Net Amount
        </th>
        </tr>
        </thead>

        <tbody class="table-body">
        <tr *ngFor="let l of CurrentItemWiseServiceController;let i = index">



        <td class="td-padding-tb  padding-right-0px"> <label class="margin-bottom-0px">{{l.BillDate | date:'MMM-dd-yyyy'}}</label></td>
        <td class="td-padding-tb padding-right-0px padding-left-2px td-elipsis-mt">{{l.PatientName}}</td>
        <td class="text-align-center td-padding-tb padding-right-4pe">{{l.Quantity}}</td>
        <td class="text-align-center td-padding-tb padding-right-4pe padding-left-0px">{{l.UnitPrice}}</td>
        <td class="td-padding-tb padding-right-5pe text-align-center padding-left-0px">{{(l.Quantity * l.UnitPrice)| number:'1.2-2' |removeComma}}</td>
        <td class="text-align-center td-padding-tb padding-left-0px padding-right-4pe">{{l.Discount| number:'1.2-2' |removeComma}}</td>
        <td class="td-padding-tb padding-right-3px text-align-center padding-left-0px padding-right-5pe">{{l.Total| number:'1.2-2' |removeComma}}</td>

        </tr>
        </tbody>



        </table>
        </div>
        </div>

        </div>
        </div>

        <div class="row" *ngIf="length2==0">
        <div class="col-md-12 padding-left-0px text-align-center">
        <label class="margin-bottom-0px color-Assign font-size-18px margin-top-3px">
        Sales are not avilable for this Service.
        </label>
        </div>
        </div>



        </div>

        









        </div>
        </div>
        </div>
        <!--<div class="table-component">
    <div class="table-responsive overflow-x-hidden">


      <table class="table table-striped margin-left-zero">

        <thead class="">
          <tr>
            <th class="td-width-3px">Code</th>

            <th class="">Name</th>

            <th class="">Lab Department </th>
            <th class="">Profile</th>



            <th class="">Service Code</th>

          </tr>
        </thead>
        <tbody class="table-body">
          <tr *ngFor="let l of CurrentTestsByLabCodeController">
            <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Code !== undefined ? l.Code : l.code}}</a></td>
            <td><a (click)="ViewServiceDetails(l)" class="nav-link-hand table-anchor">{{l.Name || l.name || l.TestName || l.testName}}</a></td>
            <td class="">
              <a class="nav-link-hand table-anchor">{{l.CategoryName || l.categoryName || l.LabDepartmentName || l.labDepartmentName}}</a>
            </td>
            <td class="">
              <a class="nav-link-hand table-anchor">{{l.ProfileName || l.profileName || (l.AgeProfile == 1 ? 'Female' : l.AgeProfile == 2 ? 'Male' : 'All')}}</a>
            </td>
            <td class="">
              <a class="nav-link-hand table-anchor">{{l.ServiceCode !== undefined ? l.ServiceCode : l.serviceCode}}</a>
            </td>
          </tr>



        </tbody>

      </table>
    </div>
  </div>-->
        </div>
        </div>
        </div>
        </div>
      </div>


      <div class="offset-md-2 col-md-12 padding-left-42px">

        <testinformation *ngIf="SelectedService"></testinformation>
      </div>

      <!--<div class="row" *ngIf="SelectedService">

      TESTING  {{SelectedService.Code}}
      </div>-->



    </div>
  </div>

</div>


